wbApp.controller('LeadsAdmissionDetailCtrl', ['$scope', '$modal', '$translate', '$timeout', 'leadSvc', 'localStorageService',
function ($scope, $modal, $translate, $timeout, leadSvc, localStorageService) {

//    $scope.lead = ...;   // Full lead object
//    $scope.dialogType = ['sendAdmissionAcceptance', 'sendAdmissionRejection', 'printAdmissionAcceptance', 'printAdmissionRejection']
    
    $scope.isSaving = false;
    $scope.model = {
        contractTemplateTypeId: null
    };
    
    switch($scope.dialogType) {
        case 'sendAdmissionAcceptance':
            $scope.contractTemplateTypeFilter = 8; // AdmissionAcceptance
            $scope.savebuttonText = $translate.instant('TXT_BTN_SEND');
            $scope.title = $translate.instant('TXT_SEND_ADMISSION_ACCEPTANCE');
            $scope.model.contractTemplateTypeId = localStorageService.get('admissionAcceptanceContractTemplateId');
            break;
        case 'printAdmissionAcceptance':
            $scope.contractTemplateTypeFilter = 8; // AdmissionAcceptance
            $scope.savebuttonText = $translate.instant('TXT_BTN_PRINT');
            $scope.title = $translate.instant('TXT_PRINT_ADMISSION_ACCEPTANCE');
            $scope.model.contractTemplateTypeId = localStorageService.get('admissionAcceptanceContractTemplateId');
            break;
        case 'sendAdmissionRejection':
            $scope.contractTemplateTypeFilter = 9; // AdmissionRejection
            $scope.savebuttonText = $translate.instant('TXT_BTN_SEND');
            $scope.title = $translate.instant('TXT_SEND_ADMISSION_REJECTION');
            $scope.model.contractTemplateTypeId = localStorageService.get('admissionRejectionContractTemplateId');
            break;
        case 'printAdmissionRejection':
            $scope.contractTemplateTypeFilter = 9; // AdmissionRejection
            $scope.savebuttonText = $translate.instant('TXT_BTN_PRINT');
            $scope.title = $translate.instant('TXT_PRINT_ADMISSION_REJECTION');
            $scope.model.contractTemplateTypeId = localStorageService.get('admissionRejectionContractTemplateId');
            break;
    }

    $scope.onDetailSave = function () {

        $scope.isSaving = true;

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
            if (!!$scope.onSaveChanges) {
                $timeout(function() {
                    $scope.onSaveChanges();
                }, 2000);
            }
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }        
        
        switch($scope.dialogType) {
            case 'sendAdmissionAcceptance':
                localStorageService.set('admissionAcceptanceContractTemplateId', $scope.model.contractTemplateTypeId);
                leadSvc.admissionAcceptanceNotification($scope.lead.id, $scope.model.contractTemplateTypeId, success, error);
                break;                
            case 'printAdmissionAcceptance':
                localStorageService.set('admissionAcceptanceContractTemplateId', $scope.model.contractTemplateTypeId);
                window.open("restapi/leads/" + $scope.lead.id + "/admission/acceptance-report?contractTemplateId=" + $scope.model.contractTemplateTypeId, '_blank');
                success();
                break;
            case 'sendAdmissionRejection':
                localStorageService.set('admissionRejectionContractTemplateId', $scope.model.contractTemplateTypeId);
                leadSvc.admissionRejectionNotification($scope.lead.id, $scope.model.contractTemplateTypeId, success, error);
                break;
            case 'printAdmissionRejection':
                localStorageService.set('admissionRejectionContractTemplateId', $scope.model.contractTemplateTypeId);
                window.open("restapi/leads/" + $scope.lead.id + "/admission/rejection-report?contractTemplateId=" + $scope.model.contractTemplateTypeId, '_blank');
                success();
                break;
        }
    }

}]);
